import { ApiService } from '../../services/api_service';
import { DataService } from '../../services/data_service';
import { formStyle } from '../../core/forms/WFormFramework';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';

export interface VersionshistorieProps {
    data: any;
    openFirstItem?: boolean;
    style?: React.CSSProperties;
    onClose?(): void;
}

export interface VersionshistorieState {
    data: any;
}

export class Versionshistorie extends React.Component<VersionshistorieProps, VersionshistorieState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: {}
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;

    componentDidMount(): void {
        this.init();
    }

    async getData(entity: string, filter: any, settings: any): Promise<any[]> {
        return (await this.dataService.async_loadData(entity, filter, settings, IDs.MOD_ETOOL_ADMIN) || {})[entity] || [];
    }

    async init(): Promise<void> {
        const bereich: string = this.apiService.getBereichKey() || null;
        const data: any = {};
        const versionshistorie: any[] = await this.getData(
            IDs.ENT_VERSIONSHISTORIE,
            // [{ field: 'bereich', op: 'IN', val: `('allgemein', '${bereich}') AND zielversion IS NOT NULL` }],
            [
                { field: 'bereich', op: 'IN', val: ['allgemein', bereich] },
                { field: 'zielversion', op: 'IS NOT NULL' }
            ],
            { sort: 'datum', sort_desc: true }
        );
        // console.log(versionshistorie, JSON.stringify(versionshistorie).length);
        versionshistorie.forEach((item: any, index: number) => {
            if (!data[item.zielversion]) {
                data[item.zielversion] = [];
            }

            if (!index && this.props.openFirstItem) {
                item.isVisible = true;
            }
            data[item.zielversion].push(item);
        });
        this.setState({ data });
    }

    render(): JSX.Element {
        return (
            <div style={{ width: '100%', minHeight: 0, display: 'flex', flexDirection: 'row', overflowY: 'auto' }}>
                <div
                    style={{
                        width: '50%', maxWidth: 600, paddingTop: 20, paddingRight: 20,
                        borderRight: '1px solid var(--color-breadcrumb-background)', boxSizing: 'border-box', ...(this.props.style || {})
                    }}
                >
                    <div style={{ fontWeight: 'bold', marginBottom: 15 }}>
                        {i18n('Änderungs- bzw. Versionshistorie', 'sys')}
                    </div>
                    {this.renderList()}
                </div>
                <div
                    style={{
                        textAlign: 'justify', width: '50%', maxWidth: 600, marginLeft: -1, paddingTop: 20, paddingLeft: 20,
                        borderLeft: '1px solid var(--color-breadcrumb-background)', boxSizing: 'border-box'
                    }}
                >
                    <div style={{ fontWeight: 'bold', marginBottom: 10 }}>
                        {i18n('Erläuterungen', 'sys')}
                    </div>
                    {renderText('Versionshistorie', this.props.data)}
                </div>
            </div>
        );
    }

    renderList(): JSX.Element[] {
        const { data } = this.state;

        return Object.keys(data).map((zielversion: string, index: number) =>
            <React.Fragment key={`faq-${index}`}>
                <div
                    className={formStyle.formTitelLight}
                    style={{
                        fontSize: '10pt', textAlign: 'left', lineHeight: 1.1, color: 'var(--color-button-text)',
                        backgroundColor: 'var(--color-button-bg)', marginRight: 0, cursor: 'pointer', userSelect: 'none'
                    }}
                    onClick={() => {
                        data[zielversion][0].isVisible = !data[zielversion][0].isVisible;
                        this.setState({ data });
                    }}
                >
                    {zielversion} / Stand: {Moment.unix(data[zielversion][0].datum).format('DD.MM.YYYY')} {data[zielversion][0].isVisible ? <>&#9660;</> : <>&#9654;</>}
                </div>
                <div
                    style={{
                        fontSize: '10pt', paddingBlock: 4, display: 'grid', gridTemplateRows: data[zielversion][0].isVisible ? '1fr' : '0fr',
                        transition: '0.25s grid-template-rows ease-in-out'
                    }}
                >
                    <ul
                        style={{
                            textAlign: 'justify', margin: 0, padding: 0, paddingRight: 10, paddingLeft: 24, overflow: 'hidden',
                            whiteSpace: 'pre-line'
                        }}
                    >
                        {/*<ul style={{ lineHeight: 1.1, textAlign: 'justify', padding: '0 4px', overflow: 'hidden', whiteSpace: 'pre-line' }}>*/}
                        {/*data[zielversion].map((item: any) => item.beschreibung || '').join('\n')*/}
                        {data[zielversion].map((item: any, index2: number) =>
                            <li key={`version-${index2}`}>
                                <b>{item.modul ? (item.modul + ' ') : ''} </b>
                                <b>{item.modul_version ? (' / ' + item.modul_version + ' ') : ''} </b>
                                {item.beschreibung || ''}
                            </li>
                        )}
                    </ul>
                </div>
            </React.Fragment>
        );
    }
}
